// https://supabase.com/docs/guides/auth/server-side/creating-a-client
import { createBrowserClient } from "@supabase/ssr"
import { Database } from "@/lib/database.types"

// Create a Supabase client for browser/client-side usage
// Uses @supabase/ssr for compatibility with server-side and middleware clients
export default createBrowserClient<Database>(process.env.NEXT_PUBLIC_SUPABASE_URL!, process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!)
